import { render, staticRenderFns } from "./DoctorCertificationForm.vue?vue&type=template&id=5d0d0227&"
import script from "./DoctorCertificationForm.vue?vue&type=script&lang=js&"
export * from "./DoctorCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports